import React, { useState } from "react";
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import "./LoginScreen.css";
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import GetUserInfo from "../GetUserInfo";
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';

const LoginScreen = ({ setLoginState }) => {
  const [form] = Form.useForm();
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const modal = Modal;

  

  const handleLogin = async (values) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/login`,
        { email: values.email, wachtwoord: values.password }
      );

      sessionStorage.setItem("jwt", JSON.stringify(response.data.token));
      sessionStorage.setItem("refresh", JSON.stringify(response.data.refreshToken));

      const user = GetUserInfo();
      if (user.rol === "Leerkracht") {
        navigate("/Leerkracht");
      } else if (user.rol === "Besteller") {
        navigate("/Admin/bestelling/ControleVoorstel");
      } else if (user.rol === "Gebruikersbeheerder") {
        navigate("/Admin/bestelling/gebruikersbeheer");
      } else if (user.rol === "Aanvrager") {
        navigate("/goedkeuring");
      }
    } catch (error) {
      console.error("Login Error:", error);
      openNotificationError("Fout bij inloggen", error);
      }

    };
  

  return (
    <div className="container">
      <div className="input-container">
        <img src="/img/logo.png" alt="Logo"  />
        <h1 className="title">Login</h1>
        <Form form={form} name="login_form" layout="vertical" onFinish={handleLogin}>
          <Form.Item name="email" rules={[{ required: true, message: 'Voer uw e-mail in!' }]}> 
            <Input prefix={<UserOutlined />} placeholder="Email" className="input" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Voer uw wachtwoord in!' }]}> 
            <Input.Password prefix={<LockOutlined />} placeholder="Wachtwoord" className="input" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="button">
              Login
            </Button>
          </Form.Item>
        </Form>
        <Link className="registerlink" to="/registreer">
          Nog geen account? Registreer hier.
        </Link>
      </div>
    </div>
  );
};

export default LoginScreen;